/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import env from 'env'

export const getUserDetails = (meta?: any) => ({
  type: 'api/user/GET_USER_DETAILS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/accounts/me/detailed`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {
    ...meta,
  },
})
getUserDetails.toString = () => 'api/user/GET_USER_DETAILS'

export const resendConfirmEmail = () => ({
  type: 'api/user/RESEND_CONFIRM_EMAIL',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/accounts/me/registration/resend`,
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
resendConfirmEmail.toString = () => 'api/user/RESEND_CONFIRM_EMAIL'

export const getShippingHistory = () => ({
  type: 'api/user/SUBSCRIPTIONS/HISTORY',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/shipments/query`,
      data: { paging: null },
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
getShippingHistory.toString = () => 'api/user/SUBSCRIPTIONS/HISTORY'

export const getPaymentHistory = () => ({
  type: 'api/user/PAYMENTS/HISTORY',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/subscriptions/current/invoices/query',
      data: { paging: null },
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
getPaymentHistory.toString = () => 'api/user/PAYMENTS/HISTORY'
